import React, { useCallback, useMemo, useState } from 'react';
import { SubCalcFieldDefinition } from '@decisions/server/DecisionsFramework/Design/Report/SubcalcFields/SubCalcFieldDefinition';
import { ComboBox, IComboBoxControlProps } from '../../inputs/ComboBox';
import { DropDownOption } from '../../inputs/DropDownOption';
import { ChartSeriaColorPanel } from './ChartSeriaColorPanel';
import { ChartSeriaActionPanel } from './ChartSeriaActionPanel';

interface IChartSeriaProps extends React.HTMLProps<{}> {
  seria: SubCalcFieldDefinition;
  selectableFields: SubCalcFieldDefinition[];
  seriaNumber: number;
  seriesLength: number;
  hideColorOption: boolean;
  comboSelect: (newValue: SubCalcFieldDefinition, seriaNumber: number) => void;
  openColorPickerDialog: (e: React.MouseEvent<Element>, seriaNumber: number) => void;
  clearColor: (seriaNumber: number) => void;
  removeSeria: (seriaNumber: number) => void;
  moveSeriaUp: (seriaNumber: number) => void;
  moveSeriaDown: (seriaNumber: number) => void;
}

export function ChartSeria({
  seria,
  selectableFields,
  seriaNumber,
  comboSelect,
  openColorPickerDialog,
  seriesLength,
  removeSeria,
  moveSeriaDown,
  moveSeriaUp,
  clearColor,
  hideColorOption,
}: IChartSeriaProps) {
  const [comboOpen, setComboOpen] = useState(false);

  const select = useCallback(
    (newValue: SubCalcFieldDefinition, seriaNumber: number) => {
      setComboOpen(false);
      comboSelect(newValue, seriaNumber);
    },
    [comboSelect]
  );

  const comboFields: SubCalcFieldDefinition[] = useMemo(() => {
    return [...selectableFields, seria];
  }, [selectableFields, seria]);

  const controllOptions: IComboBoxControlProps = useMemo(() => {
    return {
      onOpenClick: () => {
        setComboOpen(!comboOpen);
      },
      open: comboOpen,
      onClose: () => {
        setComboOpen(false);
      },
    };
  }, [comboOpen]);

  return (
    <li className="dpc-chart-series-editor__seria">
      <div className="dpc-chart-series-editor__seria-number">{`Series ${seriaNumber + 1}`}</div>
      <div className="dpc-chart-series-editor__combo">
        <ComboBox controlProps={controllOptions} hideClear={true} value={seria.OutputName} onChange={() => {}}>
          {comboFields?.map((value: SubCalcFieldDefinition, i: number) => (
            <DropDownOption key={i} index={i} onChosen={() => select(value, seriaNumber)} isChosen={false}>
              {value.OutputName}
            </DropDownOption>
          ))}
        </ComboBox>
      </div>
      <div className="dpc-chart-series-editor__bottom-panel">
        <ChartSeriaColorPanel
          hideColorOption={hideColorOption}
          openColorPickerDialog={openColorPickerDialog}
          clearColor={clearColor}
          seriaNumber={seriaNumber}
          seria={seria}
        />
        <ChartSeriaActionPanel
          seriesLength={seriesLength}
          removeSeria={removeSeria}
          moveSeriaDown={moveSeriaDown}
          moveSeriaUp={moveSeriaUp}
          seriaNumber={seriaNumber}
        />
      </div>
    </li>
  );
}
